import { putCollectionPointRefundThunk } from "../../../../reducers/collectionPointReducer";
import { IBillingRefund } from "../../../../types/billings";
import { PutCollectionPointRefundArgs } from "../../../../types/collectionPoint";
import { IModal } from "../../../../types/modal";
import { BillingChangeModal } from "../BillingChangeModal/BillingChangeModal";

interface BillingRefundChangeModalProps extends IModal {
  refund: IBillingRefund;
  isRefunded: boolean;
}

export const BillingRefundChangeModal = ({
  refund,
  isRefunded,
  isModalVisible,
  toggleModalVisibility,
}: BillingRefundChangeModalProps) => {
  return (
    <BillingChangeModal<PutCollectionPointRefundArgs>
      translationKey="collectionPoint.billingRefundChangeModal"
      thunk={putCollectionPointRefundThunk}
      payload={{ id: refund.id, isReturned: isRefunded }}
      isModalVisible={isModalVisible}
      toggleModalVisibility={toggleModalVisibility}
      isPaid={isRefunded}
    />
  );
};
